import React from 'react';

import './DeviceItemAlarm.scss';

export default class DeviceItemAlarm extends React.PureComponent {

    
    render() {
        // console.log(props.device.alerts);
        const typeText = this.props.type;
        // const hasAlarms = keyExists("alerts", this.props.device, "array");
        // const activeAlerts = hasAlarms ? this.props.device.alerts.filter(al => al.state === "ACTIVE") : [];
        // const deviceInAlert = Array.isArray(props.device.alerts) &&  props.device.alerts.length > 0 ? "alarmOn" : "alarmOff";
        // const deviceInAlert = activeAlerts.length > 0 ? "alarmOn" : "alarmOff";
        
        const deviceInAlert = this.props.device.alertCount.active.total > 0 ? "alarmOn" : "alarmOff";

        // const alerts = props.device.alerts !== undefined && Array.isArray(props.device.alerts) ? props.device.alerts.length : 0;

        return(
            <span className={`device-item-alarm ${typeText} ${deviceInAlert}`}>
                <p><small>{typeText}</small></p>
                <p>{this.props.alarmCount}</p>
            </span>
        );
    }
    
}